import { createStyles, makeStyles, Theme } from "@material-ui/core";
import useText from "constants/text";
import { Notification } from "generated/graphql";
import { EasyColisIcon } from "icons";
import moment from "moment";
import React from "react";

export interface ItemNotificationProps {
  notification?: Notification;
  onClick?: any;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      cursor: "pointer",
      width: "100%",
      background: "#fff",
      display: "flex",
      borderBottom: " 1px solid #DFDFDF",
      paddingBottom: 30,
      paddingTop: 30,
    },
    header: {
      display: "flex",
      width: "100%",
      justifyContent: "space-between",
      flex: 1,
    },
    text: {
      color: "#acacac",
      fontSize: 12,
      marginBottom: 10,
    },
    time: {
      fontSize: 14,
      color: theme.palette.primary.main,
      marginRight: 10,
    },
    title: {
      fontWeight: 800,
      color: theme.palette.primary.main,
      fontSize: 18,
    },
    flex: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
    },
    full: {
      flex: 1,
      marginLeft: 10,
    },
  })
);

export function ItemNotification({ notification, onClick }: ItemNotificationProps) {
  const styles = useStyles();
  const { text } = useText();
  const serviceNameMap={ NT:text.homePage.national_transport_title, MAD:text.all.dedicated_courier, MSG:text.homePage.distribution_title, Course:text.homePage.course_title }
  return (
    <div className={styles.root}>
      <div className={styles.flex}>
        <EasyColisIcon />
      </div>
      <div className={`${styles.flex} ${styles.full}`}>
        <div className={styles.header}>
          <div className={styles.title}>{serviceNameMap[notification?.service]||text.homePage.distribution_title}</div>
          <div className={styles.time}>{moment(notification.createdAt).format(text.all.local_time_ago)}</div>
        </div>
        <div className={styles.text}>{notification.content}</div>
      </div>
    </div>
  );
}
